import axios from "axios";
export default async () => {
  const url = `${process.env.REACT_APP_IP_URL}/getip`;
  const { data } = await axios.get<{ ip: string }>(url);
  return data ? data.ip : "";
};
